// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bot-settings {
  font-family: "DM Sans", sans-serif;
  margin: 20px;
  margin-top: 0;
}

.bot-settings .selection-container {
  align-items: center;
  max-width: 1100px;
}

.usage-bar-wrapper {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  animation: fadeInUsage 0.4s ease;
}

@keyframes fadeInUsage {
  from { opacity: 0; }
  to { opacity: 1; }
}

.usage-bar-label {
  font-size: 13px;
  color: #888;
  white-space: nowrap;
  font-weight: 500;
}

.usage-bar-track {
  width: 120px;
  height: 8px;
  background-color: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.usage-bar-fill {
  height: 100%;
  background-color: #5616ea;
  border-radius: 4px;
  transition: width 0.8s ease;
  transform-origin: left;
  animation: barFillGrow 0.8s ease;
}

@keyframes barFillGrow {
  from { transform: scaleX(0); }
  to { transform: scaleX(1); }
}

.usage-bar-fill-full {
  background-color: #ef4444;
}

.usage-bar-percent {
  font-size: 12px;
  color: #9ca3af;
  font-weight: 400;
  white-space: nowrap;
}

.bot-select-item.Mui-selected {
  background-color: #5616ea !important;
  color: white !important;
}

.bot-select-item.Mui-selected:hover {
  background-color: #4a14d6 !important;
}

.bot-select-item:hover {
  background-color: #e0f7fa;
}

.settings-tabs {
  display: flex;
  margin-bottom: 30px;
  border-bottom: 2px solid #ddd;
  max-width: 1100px;
  overflow-x: auto;
  overflow-y: hidden;
}

.settings-tabs::-webkit-scrollbar {
  display: none;
}

.tab {
  flex: 1 1;
  padding: 12px;
  padding-bottom: 16px;
  text-align: center;
  cursor: pointer;
  font-size: 17px !important;
  background-color: transparent;
  border: none;
  position: relative;
  outline: none;
}
.tab::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 4.5px;
  background-color: #5616ea;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s ease;
  will-change: transform;
}

.tab:hover::after,
.tab.active::after {
  transform: scaleX(1);
}

.tab.initial-attention::after {
  animation: tabUnderlineGrow 0.4s ease;
}

@keyframes tabUnderlineGrow {
  from { transform: scaleX(0); }
  to { transform: scaleX(1); }
}

.tab.active {
  font-weight: bold;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.tab-content {
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
  gap: 15px;
}

.tab-with-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  position: relative;
}

.tab .tab-badge {
  position: static;
  background-color: #5616ea;
  color: #fff;
  border-radius: 8px;
  padding: 5px;
  padding-bottom: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  box-shadow: 0 2px 6px rgba(94, 27, 255, 0.4);
  transform: translateY(-8px);
  transition: all 0.2s ease;
}

.welcome-message-input {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  max-width: 1000px;
  width: 100%;
  resize: vertical;
  line-height: 1.5;
  min-height: 50px;
  box-sizing: border-box;
}

.system-prompt-input {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  max-width: 1000px;
  width: 100%;
  height: 300px;
  resize: vertical;
  line-height: 1.5;
  min-height: 50px;
  box-sizing: border-box;
}

.save-btn {
  align-self: flex-start;
  background-color: #5616ea;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.2s ease;
}

.save-btn:hover {
  background-color: #005f8a;
}

.knowledge-parent-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 1100px;
}

.knowledge-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  transition: background-color 0.3s ease;
  padding: 20px;
}

.header-title {
  width: 150px;
  font-size: 16px;
}

.knowledge-header p {
  margin: 0;
}

.header-title-count {
  display: flex;
  gap: 20px;
  align-items: center;
}

.create-here-button {
  background-color: transparent;
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  color: #005f8a;
  cursor: pointer;
  text-decoration: underline;
  font-size: 18px;
  font-weight: 600;
}

.no-bots-warning-icon {
  font-size: 30px;
  color: #efd80c;
}

.knowledge-container {
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.3s ease;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  max-width: 1100px;
}

.knowledge-loading-spinner {
  width: 14px;
  height: 14px;
  border: 3px solid #ffffff;
  border-top: 3px solid #5616ea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.knowledge-status-link {
  display: flex;
  gap: 8px;
  align-items: center;
}

.knowledge-okay-status-icon {
  color: #5616ea;
}

.knowledge-bad-status-icon {
  color: red;
}

.knowledge-link {
  width: 60%;
}

.knowledge-add-buttons-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 15px;
}

.knowledge-add-button-parent {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.knowledge-add-button {
    border: none;
    background-color: #5616ea;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    padding: 8px 14px;
    border-radius: 8px;
    color: white;
    transition: 0.2s ease, color 0.2s ease;
    width: auto;
    min-width: 140px;
}

.knowledge-add-button:hover {
  background-color: #4a14d6;
  cursor: pointer;
  transform: translateY(-2px);
}

.knowledge-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  padding-bottom: 15px;
  padding-top: 0px;
}

.knowledge-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  gap: 15px;
}

.knowledge-item-separator {
  border-top: 1px solid #ddd;
  margin: 0px;
  padding: 0;
  width: 100%;
}

.knowledge-item h3 {
  font-size: 16px;
  margin-top: 0;
  color: #5e5e5e;
}

.knowledge-date-action-container {
  display: flex;
  gap: 15px;
}

.knowledge-created-at {
  display: flex;
  align-items: center;
  gap: 10px;
}

.knowledge-created-at p {
  font-size: 14px;
  margin: 0;
  font-variant-numeric: tabular-nums;
  min-width: 86px;
}

.knowledge-created-at-icon {
  color: #5e5e5e;
}

.knowledge-actions {
  display: flex;
  gap: 15px;
}

.knowledge-action-button {
  min-width: 36px;
  height: 28px;
  padding: 0 6px;
  font-size: 12px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.2s ease, color 0.2s ease;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  color: #464646;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-shrink: 0;
}

.knowledge-action-button:hover {
  background-color: #ededed;
  transform: scale(1.1);
}

.knowledge-action-button:disabled {
  background-color: #ededed;
  transform: scale(1.0);
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .settings-tabs {
    width: 100%;
    max-width: 100%;
  }

  .tab {
    color: rgb(34, 34, 34);
    padding: 15px;
    padding-top: 10px;
  }

  .tab-content {
    padding: 20px;
  }

  .beta-label {
    margin-left: 0px;
  }

  .knowledge-link {
    width: 100%;
  }

  .knowledge-date-action-container {
    justify-content: space-between;
    width: 100%;
  }

  .knowledge-actions {
    gap: 10px;
  }

  .bot-settings .selection-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .usage-bar-wrapper {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/botSettings.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,OAAO,oBAAoB,EAAE;EAC7B,KAAK,oBAAoB,EAAE;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;EACtB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,OAAO,oBAAoB,EAAE;EAC7B,KAAK,oBAAoB,EAAE;AAC7B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;EAC5C,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,UAAU;EACV,SAAS;EACT,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mDAAmD;EACnD,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,sCAAsC;IACtC,WAAW;IACX,gBAAgB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".bot-settings {\r\n  font-family: \"DM Sans\", sans-serif;\r\n  margin: 20px;\r\n  margin-top: 0;\r\n}\r\n\r\n.bot-settings .selection-container {\r\n  align-items: center;\r\n  max-width: 1100px;\r\n}\r\n\r\n.usage-bar-wrapper {\r\n  margin-left: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-shrink: 0;\r\n  animation: fadeInUsage 0.4s ease;\r\n}\r\n\r\n@keyframes fadeInUsage {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n.usage-bar-label {\r\n  font-size: 13px;\r\n  color: #888;\r\n  white-space: nowrap;\r\n  font-weight: 500;\r\n}\r\n\r\n.usage-bar-track {\r\n  width: 120px;\r\n  height: 8px;\r\n  background-color: #e5e7eb;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.usage-bar-fill {\r\n  height: 100%;\r\n  background-color: #5616ea;\r\n  border-radius: 4px;\r\n  transition: width 0.8s ease;\r\n  transform-origin: left;\r\n  animation: barFillGrow 0.8s ease;\r\n}\r\n\r\n@keyframes barFillGrow {\r\n  from { transform: scaleX(0); }\r\n  to { transform: scaleX(1); }\r\n}\r\n\r\n.usage-bar-fill-full {\r\n  background-color: #ef4444;\r\n}\r\n\r\n.usage-bar-percent {\r\n  font-size: 12px;\r\n  color: #9ca3af;\r\n  font-weight: 400;\r\n  white-space: nowrap;\r\n}\r\n\r\n.bot-select-item.Mui-selected {\r\n  background-color: #5616ea !important;\r\n  color: white !important;\r\n}\r\n\r\n.bot-select-item.Mui-selected:hover {\r\n  background-color: #4a14d6 !important;\r\n}\r\n\r\n.bot-select-item:hover {\r\n  background-color: #e0f7fa;\r\n}\r\n\r\n.settings-tabs {\r\n  display: flex;\r\n  margin-bottom: 30px;\r\n  border-bottom: 2px solid #ddd;\r\n  max-width: 1100px;\r\n  overflow-x: auto;\r\n  overflow-y: hidden;\r\n}\r\n\r\n.settings-tabs::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.tab {\r\n  flex: 1;\r\n  padding: 12px;\r\n  padding-bottom: 16px;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  font-size: 17px !important;\r\n  background-color: transparent;\r\n  border: none;\r\n  position: relative;\r\n  outline: none;\r\n}\r\n.tab::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: -2px;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 4.5px;\r\n  background-color: #5616ea;\r\n  transform: scaleX(0);\r\n  transform-origin: left;\r\n  transition: transform 0.4s ease;\r\n  will-change: transform;\r\n}\r\n\r\n.tab:hover::after,\r\n.tab.active::after {\r\n  transform: scaleX(1);\r\n}\r\n\r\n.tab.initial-attention::after {\r\n  animation: tabUnderlineGrow 0.4s ease;\r\n}\r\n\r\n@keyframes tabUnderlineGrow {\r\n  from { transform: scaleX(0); }\r\n  to { transform: scaleX(1); }\r\n}\r\n\r\n.tab.active {\r\n  font-weight: bold;\r\n  border-top-left-radius: 10px;\r\n  border-top-right-radius: 10px;\r\n}\r\n\r\n.tab-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: rgba(255, 255, 255, 0.75);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border-radius: 20px;\r\n  padding: 30px;\r\n  box-shadow: 0 10px 30px rgba(0,0,0,0.05);\r\n  gap: 15px;\r\n}\r\n\r\n.tab-with-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  position: relative;\r\n}\r\n\r\n.tab .tab-badge {\r\n  position: static;\r\n  background-color: #5616ea;\r\n  color: #fff;\r\n  border-radius: 8px;\r\n  padding: 5px;\r\n  padding-bottom: 4px;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  box-shadow: 0 2px 6px rgba(94, 27, 255, 0.4);\r\n  transform: translateY(-8px);\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.welcome-message-input {\r\n  padding: 10px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n  font-size: 16px;\r\n  max-width: 1000px;\r\n  width: 100%;\r\n  resize: vertical;\r\n  line-height: 1.5;\r\n  min-height: 50px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.system-prompt-input {\r\n  padding: 10px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n  font-size: 16px;\r\n  max-width: 1000px;\r\n  width: 100%;\r\n  height: 300px;\r\n  resize: vertical;\r\n  line-height: 1.5;\r\n  min-height: 50px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.save-btn {\r\n  align-self: flex-start;\r\n  background-color: #5616ea;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.save-btn:hover {\r\n  background-color: #005f8a;\r\n}\r\n\r\n.knowledge-parent-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  max-width: 1100px;\r\n}\r\n\r\n.knowledge-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  border-radius: 10px;\r\n  transition: background-color 0.3s ease;\r\n  padding: 20px;\r\n}\r\n\r\n.header-title {\r\n  width: 150px;\r\n  font-size: 16px;\r\n}\r\n\r\n.knowledge-header p {\r\n  margin: 0;\r\n}\r\n\r\n.header-title-count {\r\n  display: flex;\r\n  gap: 20px;\r\n  align-items: center;\r\n}\r\n\r\n.create-here-button {\r\n  background-color: transparent;\r\n  border: none;\r\n  outline: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  color: #005f8a;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n}\r\n\r\n.no-bots-warning-icon {\r\n  font-size: 30px;\r\n  color: #efd80c;\r\n}\r\n\r\n.knowledge-container {\r\n  overflow: hidden;\r\n  transition: max-height 0.3s ease, opacity 0.3s ease;\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: rgba(255, 255, 255, 0.75);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  max-width: 1100px;\r\n}\r\n\r\n.knowledge-loading-spinner {\r\n  width: 14px;\r\n  height: 14px;\r\n  border: 3px solid #ffffff;\r\n  border-top: 3px solid #5616ea;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.knowledge-status-link {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n}\r\n\r\n.knowledge-okay-status-icon {\r\n  color: #5616ea;\r\n}\r\n\r\n.knowledge-bad-status-icon {\r\n  color: red;\r\n}\r\n\r\n.knowledge-link {\r\n  width: 60%;\r\n}\r\n\r\n.knowledge-add-buttons-row {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.knowledge-add-button-parent {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\n.knowledge-add-button {\r\n    border: none;\r\n    background-color: #5616ea;\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    text-align: center;\r\n    padding: 8px 14px;\r\n    border-radius: 8px;\r\n    color: white;\r\n    transition: 0.2s ease, color 0.2s ease;\r\n    width: auto;\r\n    min-width: 140px;\r\n}\r\n\r\n.knowledge-add-button:hover {\r\n  background-color: #4a14d6;\r\n  cursor: pointer;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.knowledge-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  padding: 20px;\r\n  padding-bottom: 15px;\r\n  padding-top: 0px;\r\n}\r\n\r\n.knowledge-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background-color: transparent;\r\n  gap: 15px;\r\n}\r\n\r\n.knowledge-item-separator {\r\n  border-top: 1px solid #ddd;\r\n  margin: 0px;\r\n  padding: 0;\r\n  width: 100%;\r\n}\r\n\r\n.knowledge-item h3 {\r\n  font-size: 16px;\r\n  margin-top: 0;\r\n  color: #5e5e5e;\r\n}\r\n\r\n.knowledge-date-action-container {\r\n  display: flex;\r\n  gap: 15px;\r\n}\r\n\r\n.knowledge-created-at {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.knowledge-created-at p {\r\n  font-size: 14px;\r\n  margin: 0;\r\n  font-variant-numeric: tabular-nums;\r\n  min-width: 86px;\r\n}\r\n\r\n.knowledge-created-at-icon {\r\n  color: #5e5e5e;\r\n}\r\n\r\n.knowledge-actions {\r\n  display: flex;\r\n  gap: 15px;\r\n}\r\n\r\n.knowledge-action-button {\r\n  min-width: 36px;\r\n  height: 28px;\r\n  padding: 0 6px;\r\n  font-size: 12px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: 0.2s ease, color 0.2s ease;\r\n  background-color: #f3f4f6;\r\n  border: 1px solid #e5e7eb;\r\n  color: #464646;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-sizing: border-box;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.knowledge-action-button:hover {\r\n  background-color: #ededed;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.knowledge-action-button:disabled {\r\n  background-color: #ededed;\r\n  transform: scale(1.0);\r\n  cursor: not-allowed;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .settings-tabs {\r\n    width: 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .tab {\r\n    color: rgb(34, 34, 34);\r\n    padding: 15px;\r\n    padding-top: 10px;\r\n  }\r\n\r\n  .tab-content {\r\n    padding: 20px;\r\n  }\r\n\r\n  .beta-label {\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .knowledge-link {\r\n    width: 100%;\r\n  }\r\n\r\n  .knowledge-date-action-container {\r\n    justify-content: space-between;\r\n    width: 100%;\r\n  }\r\n\r\n  .knowledge-actions {\r\n    gap: 10px;\r\n  }\r\n\r\n  .bot-settings .selection-container {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .usage-bar-wrapper {\r\n    margin-left: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
